import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
import { ThongTinChoVay } from "./ThongTinChoVay";
import { ChiTietDongLai } from "./ChiTietDongLai";
import { LichSuTraBotGoc } from "./LichSuTraBotGoc";
import { LichSuVayThem } from "./LichSuVayThem";

import { TaiSanCamCo } from "./TaiSanCamCo";
import { LichSuGiaHanHopDong } from "./LichSuGiaHanHopDong";
import { LichSuGiaHanNgayTra } from "./LichSuGiaHanNgayTra";
import { GhiChu } from "./GhiChu";
import { FileDinhKem } from "./FileDinhKem";
import NhanVayApi from "service/nhanVayApi";
import configs from "constants/configs";
import { getDate } from "utils/formatDate";

export const ModalChiTietHopDong = (props) => {
  const initHopDong = {
    Address: "",
    AddressCmt: "",
    AnhKhachHang: "",
    BeforeAfter: 0,
    Birthday: "01/01/1900 00:00:00",
    Cmt: "",
    CountTypePaid: 0,
    CustomerId: 0,
    DateCmt: "01/01/1900 00:00:00",
    DsTaiSanNhanVay: [],
    FileDinhKems: null,
    GhiChu: "",
    GiayToTheChap: "",
    KieuLaiSuat: 0,
    LaiNgay: 0,
    MaNhanVay: "",
    NgayTao: "01/01/1900 00:00:00",
    NgayTra: "01/01/1900 00:00:00",
    NgayVay: "01/01/1900 00:00:00",
    NguoiTao: "",
    NhanVayID: 0,
    Phone: "",
    SoLanTra: 0,
    Sotienvay: 0,
    TenKhachHang: "",
    TypePaid: 0,
    LaiSuat: "",
  };
  const [hopdong, setDataHopDong] = useState(initHopDong);
  // useFocusEffect(
  //   React.useCallback(() => {
  //     ChiTietHopDong();
  //   }, [hopdong])
  // );

  // const isFocused = useIsFocused();
  useEffect(() => {
    ChiTietHopDong();
  }, []);

  const ChiTietHopDong = () => {
    NhanVayApi.getChiTietHopDong1(props.nhanvayId).then((response) => {
      setDataHopDong({
        Address: response.data.Address,
        AddressCmt: response.data.AddressCmt,
        AnhKhachHang: response.data.AnhKhachHang,
        BeforeAfter: response.data.BeforeAfter,
        Birthday: response.data.Birthday,
        Cmt: response.data.Cmt,
        CountTypePaid: response.data.CountTypePaid,
        CustomerId: response.data.CustomerId,
        DateCmt: response.data.DateCmt,
        DsTaiSanNhanVay: response.data.DsTaiSanNhanVay,
        FileDinhKems: response.data.FileDinhKems,
        GhiChu: response.data.GhiChu,
        GiayToTheChap: response.data.GiayToTheChap,
        KieuLaiSuat: response.data.KieuLaiSuat,
        LaiNgay: response.data.LaiNgay,
        MaNhanVay: response.data.MaNhanVay,
        NgayTao: response.data.NgayTao,
        NgayTra: response.data.NgayTra,
        NgayVay: response.data.NgayVay,
        NguoiTao: response.data.NguoiTao,
        NhanVayID: response.data.NhanVayID,
        Phone: response.data.Phone,
        SoLanTra: response.data.SoLanTra,
        Sotienvay: response.data.Sotienvay,
        TenKhachHang: response.data.TenKhachHang,
        TypePaid: response.data.TypePaid,
        LaiSuat: response.data.LaiSuat,
      });
    });
  };

  const returnImageLink = (strImage) => {
    if (strImage === "" || strImage == null) {
      return configs.imageServer + "/images/no_image.png";
    } else {
      if (strImage && strImage.indexOf("http") > -1) {
        return strImage;
      } else {
        if (
          strImage.substring(0, 7) == "Morman/" ||
          strImage.substring(0, 5) == "Temp/"
        ) {
          return configs.apiViewUpload + strImage;
        } else {
          return configs.imageServer + strImage;
        }
      }
    }
  };

  //Lấy Tong Ban Ghi Chi Tiet Dong Lai
  const [totalChiTietDongLai, setTotalChiTietDongLai] = useState("");
  const TongChiTietDongLaiShow = (total) => {
    setTotalChiTietDongLai(total.toString());
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            {/* <i className="mdi mdi-file-document"></i> */}
            <img src="/app-assets/images/icon-chi-tiet-lich-su.png" />
          </span>
          <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
            Chi tiết hợp đồng:{" "}
          </span>{" "}
          <span className="color-xanh-bold">{hopdong.MaNhanVay}</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="form-thongtin-kh-new">
          <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
            <div className="card collapse-icon accordion-icon-rotate">
              <div id="heading61" className="card-header ">
                <a
                  data-toggle="collapse"
                  data-parent="#accordionWrap6"
                  href="#accordion61"
                  aria-expanded="true"
                  aria-controls="accordion61"
                  className="card-title lead"
                >
                  <img src="/app-assets/images/icon-thong-tin-khach-vay-v2.png" />{" "}
                  <span className="color-xanh-bold"> Thông tin chủ nợ</span>
                </a>
              </div>
              <div className="card-collapse collapse show">
                <div className="card-content">
                  <div className="card-body">
                    <div className="thongtin-kh-new">
                      <div className="row">
                        <div className="col-md-2 no-image">
                          <div
                            className="col-md-2 no-image main-slider"
                            id="main-slider1"
                          >
                            <a
                              href={
                                hopdong.AnhKhachHang &&
                                hopdong.AnhKhachHang.indexOf("http") > -1
                                  ? hopdong.AnhKhachHang
                                  : hopdong.AnhKhachHang.indexOf(
                                      "/Upload/TaiSanImage/"
                                    ) > -1
                                  ? configs.imageServer + hopdong.AnhKhachHang
                                  : configs.apiViewUpload + hopdong.AnhKhachHang
                              }
                              data-fancybox="images"
                            >
                              <img
                                alt=""
                                id="ctl00_ContentPlaceHolder1_customerImage"
                                disabled="disabled"
                                className="img-responsive img-thong-tin-khach-vay "
                                src={
                                  hopdong.AnhKhachHang &&
                                  hopdong.AnhKhachHang.indexOf("http") > -1
                                    ? hopdong.AnhKhachHang
                                    : hopdong.AnhKhachHang.indexOf(
                                        "/Upload/TaiSanImage/"
                                      ) > -1
                                    ? configs.imageServer + hopdong.AnhKhachHang
                                    : configs.apiViewUpload +
                                      hopdong.AnhKhachHang
                                }
                              />
                            </a>
                          </div>
                        </div>

                        <div className="col-md-8">
                          <ul className="list-detailHD">
                            <li>
                              {" "}
                              <span className="color-xanh-bold">
                                {hopdong.TenKhachHang}
                              </span>{" "}
                            </li>
                            <li>
                              {" "}
                              <img src="/app-assets/images/icon-birthday-v2.png" />
                              <span className="color7">
                                &nbsp;
                                {getDate(hopdong.Birthday)
                                  ? getDate(hopdong.Birthday)
                                  : "Không có thông tin"}
                              </span>{" "}
                            </li>
                            <li>
                              {" "}
                              <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                              <span className="color7">
                                &nbsp;
                                {hopdong.Phone
                                  ? hopdong.Phone
                                  : "Không có thông tin"}
                              </span>
                            </li>
                            <li>
                              {" "}
                              <img src="/app-assets/images/icon-dia-chi-v2.png" />{" "}
                              <span className="color7">
                                &nbsp;
                                {hopdong.Address
                                  ? hopdong.Address
                                  : "Không có thông tin"}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-detail-hd">
          <Tabs className="tab-detail-mm">
            <Tab
              eventKey="thongtinvay"
              title={<h4 className="nav-link  tab-v2">Thông tin vay</h4>}
            >
              <ThongTinChoVay hopdong={hopdong} />
            </Tab>
            <Tab
              eventKey="chitietdonglai"
              title={
                <h4 className="nav-link  tab-v2">
                  <div className="badge badge-pill-v3 background-tim">
                    {totalChiTietDongLai}
                  </div>{" "}
                  Chi tiết đóng lãi
                </h4>
              }
            >
              <ChiTietDongLai
                hopdong={hopdong}
                TongChiTietDongLaiShow={TongChiTietDongLaiShow}
                nhanvayId={props.nhanvayId}
              />
            </Tab>
            <Tab
              eventKey="lichsuvaythem"
              title={<h4 className="nav-link tab-v2">Lịch sử vay thêm</h4>}
            >
              <LichSuVayThem hopdong={hopdong} nhanvayId={props.nhanvayId} />
            </Tab>
            <Tab
              eventKey="lichsutrabotgoc"
              title={<h4 className="nav-link tab-v2">Lịch sử trả bớt gốc</h4>}
            >
              <LichSuTraBotGoc hopdong={hopdong} nhanvayId={props.nhanvayId} />
            </Tab>
            <Tab
              eventKey="taisancamco"
              title={<h4 className="nav-link tab-v2">Tài sản thế chấp</h4>}
              // onEnter={runSlider}
            >
              <TaiSanCamCo hopdong={hopdong} />
            </Tab>
            <Tab
              eventKey="lichsugiahanhopdong"
              title={
                <h4 className="nav-link tab-v2">Lịch sử gia hạn hợp đồng</h4>
              }
            >
              <LichSuGiaHanHopDong nhanvayId={props.nhanvayId} />
            </Tab>
            <Tab
              eventKey="lichsugiahanngaytra"
              title={
                <h4 className="nav-link tab-v2">Lịch sử gia hạn ngày trả</h4>
              }
            >
              <LichSuGiaHanNgayTra nhanvayId={props.nhanvayId} />
            </Tab>
            <Tab
              eventKey="ghichu"
              title={<h4 className="nav-link tab-v2">Ghi chú</h4>}
            >
              <GhiChu nhanvayId={props.nhanvayId} />
            </Tab>
            <Tab
              eventKey="fileDinhKem"
              title={<h4 className="nav-link  tab-v2">File đính kèm</h4>}
            >
              <FileDinhKem nhanvayId={props.nhanvayId} />
            </Tab>
          </Tabs>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
